<template>
  <div>
    <mtd-menu
      ref="accountMenuRef"
      model-value="1"
      mode="horizontal"
      class="login-menu"
      @select="handleSelect"
    >
      <mtd-submenu name="2" class="account" popper-class="custom-popper">
        <template #title>
          <div class="login-container">
            <img
              src="https://img-ap-hongkong.mykeeta.net/osgeujiemo/94f9aac2915a892967750efcfe8916e01518.png"
              class="login-img"
            />
            <span class="login-name">{{ operatorMis }}</span>
          </div>
        </template>
        <mtd-menu-item name="payroll">
          {{
            $getText("O_Accounts_payroll_dc8I", {
              defaultValue: "发薪账户管理",
            })
          }}</mtd-menu-item
        >
        <mtd-menu-item name="report">
          {{
            $getText("O_Integrity_reporting_ChsK", { defaultValue: "廉政举报" })
          }}
        </mtd-menu-item>
        <mtd-menu-item name="logout">
          {{ $getText("O_Quit_SPMp", { defaultValue: "退出" }) }}</mtd-menu-item
        >
      </mtd-submenu>
    </mtd-menu>
    <reportDialog ref="reportDialogRef" />
  </div>
</template>

<script>
import { goToLogout } from "../utils/request.js";
import reportDialog from "./ReportDialog.vue";

export default {
  name: "AccountMenu",
  components: {
    reportDialog,
  },
  data() {
    return {
      reportDialogRef: null,
      operatorMis:
        window.localStorage.getItem("rss_supplier_operator_mis") ||
        this.$getText("O_mis_unknown_MauZ", { defaultValue: "未知mis" }),
    };
  },
  methods: {
    linkToPayrollAccountManagement() {
      window.location.href = `${window.location.origin}/courier/payroll/accountManagement.html`;
    },
    showReportDialog() {
      this.$refs.reportDialogRef.openDialog();
    },
    handleSelect(menuItem) {
      if (menuItem.name === "payroll") this.linkToPayrollAccountManagement();
      if (menuItem.name === "report") this.showReportDialog();
      if (menuItem.name === "logout") goToLogout();
    },
  },
};
</script>

<style lang="scss" scoped>
.login-container {
  display: flex;
  align-items: center;

  .login-img {
    margin-inline-end: 4px;
    width: 20px;
    height: 20px;
  }

  .login-name {
    color: #111925;
    margin-inline-end: 4px;
  }
}

.login-menu :deep(.mtd-submenu-title) {
  padding: 0;
}

.login-menu :deep(.mtd-submenu-text) {
  height: 100%;
}

:deep() .mtdicon.mtdicon-down-thick.mtd-submenu-direction {
  font-size: 18px;
  // vertical-align: middle;
}
:deep() .mtdicon.mtdicon-down-thick.mtd-submenu-direction:hover {
  font-size: 18px;
}
:deep() .mtd-submenu-title:hover .mtd-submenu-direction {
  color: #00b85c !important;
}
</style>

<style lang="scss">
:deep() .mtd-submenu-dropdown {
  width: 320px !important;
}

.custom-popper {
  width: 306px !important;

  .mtd-menu-item:hover {
    background-color: #f3f3f4;
  }

  .mtd-menu-item-title:hover {
    color: #000 !important;
  }
}
</style>
